import { useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import Chat from '../../common/chat/Chat.tsx';

export default function TicketAdminItem() {
	const { id } = useParams();

	if (!id) return;

	return (
		<Box className={'relative mt-3 flex w-full gap-3'}>
			<Chat type={'admin'} id={+id} layout={true} />
		</Box>
	);
}
